import { render, staticRenderFns } from "./InvestmentOptionsProfileSection.vue?vue&type=template&id=7ba971dd"
import script from "./InvestmentOptionsProfileSection.vue?vue&type=script&lang=js"
export * from "./InvestmentOptionsProfileSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports